<template>
    <!--上传banner图-->
    <div class="container">
        <div class="handleBox flex flex-c flex-b">
            <p class="navTitle">图片管理 ></p>
        </div>
        <div class="table" style="height:calc( 100% - 70px );margin-top:0px;padding: 0;">
            <div class="photoBox">
                <div class="photo flex flex-wrap">
                    <div v-if="path!=''">
                        <el-image :src='`${path}`' fit="cover" @click="showImg(path)"></el-image>
                        <i class="el-icon-error" @click="deletePhoto()"></i>
                    </div>
                    <label v-if="path==''">
                        <i class="el-icon-plus"></i>
                        <input type="file" class="uploadphoto" :value="filevalue" style="display:none" @change="upload()" />
                    </label>
                </div>
            </div>
        </div>

        <!-- 图片放大查看 -->
        <el-dialog title="图片查看" :visible.sync="dialogVisible" :modal-append-to-body="false">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template> 
<script>
    import axios from 'axios';
    export default {
        data: function () {
            return {
                path: '',
                dialogImageUrl: '',
                dialogVisible: false,
                filevalue: ''
            }
        },
        mounted() {
            this.getPath()
        },
        methods: {
            getPath() {
                this.http.post('/Setting/getImage').then(re => {
                    this.path = this.domain + re;
                })
            },
            //图片和附件上传获取接口返回的路径
            upload: function () {
                var loads = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                    customClass: 'myLoading',
                });
                let url = '/Setting/upload';
                for (var i = 0; i < document.querySelector('.uploadphoto').files.length; i++) {
                    var formData = new FormData();
                    formData.append('image', document.querySelector('.uploadphoto').files[i]);
                    axios.post(this.domain + url, formData).then(re => {
                        loads.close();
                        this.filevalue = "";
                        if (re.data.code == 200) {
                            this.filevalue = "";
                            console.log(re.data.data)
                            this.path = this.domain +  re.data.data;
                            // this.getPath();
                        } else {
                            this.$message.error(re.data.msg);
                        }
                    }).catch(function (error) { // 请求失败处理
                        loads.close();
                    });
                }
            },
            // 图片转换
            // getImgUrl(item) {
            //     var url = this.http.domain + '/' + item;
            //     return url;
            // },
            // 查看图片
            showImg: function (url) {
                console.log(url)
                this.dialogImageUrl = url;
                this.dialogVisible = true;
            },
            // 图片清空
            deletePhoto() {
                this.path = ''
            },
        }
    }
</script>
<style>
    .el-dialog{
        height: 79%;
        overflow: auto;
    }
</style>
